import React from 'react';
import { Tag } from './../../Tag';
import './GradesGoalGraph.scss';
import {
  usage,
  mix,
  inquiries,
  age,
  paymentHistory,
  config,
} from './GradesGoalGraph.config';
import classnames from 'classnames';

// left to right

function Line({ bgColorClass, borderColorClass }) {
  const className = `goalLineStyle ${bgColorClass} ${borderColorClass}`.trim();
  return <div className={className} />;
}

function Rectangle({ bgColorClass, borderColorClass, text }) {
  const bgColor =
    !text.current && !text.recommended
      ? 'bgGray025'
      : `${bgColorClass} ${borderColorClass}`;
  const className = `${bgColor} goalRectangleStyle flex-container justify-center align-items-center text-12 fontWhite`;

  return <div className={className}>{text.current || text.recommended}</div>;
}

function TextBelow({
  topText,
  midText,
  bottomText,
  datatestid,
  isRectangleLegend,
  textClasses,
}) {
  let topTextClasses = classnames(
    'textBelow topText caption m-text-12',
    textClasses || 'text-14 ',
  );

  let midTextString = midText;
  if (isRectangleLegend) {
    topTextClasses = 'textBelow topText text-12 fontGray8 bold';
    if (topText === 'F') {
      midTextString = '71-100%';
    }
  }
  return (
    <div className="textBelowContainer">
      <div
        className={topTextClasses}
        datatestid={datatestid ? `${datatestid}-toptext` : null}
      >
        {topText}
      </div>
      <div
        className={
          'textBelow Body-2 midText gray7 text-12 m-text-12 normal-weight'
        }
        datatestid={datatestid ? `${datatestid}-midtext` : null}
      >
        {midTextString}
      </div>
      <div
        className={'textBelow midText gray7 text-14 m-text-12'}
        datatestid={datatestid ? `${datatestid}-belowtext` : null}
      >
        {bottomText ? bottomText : null}
      </div>
    </div>
  );
}

function GradesGoalGraph({
  you,
  goal,
  type,
  datatestid,
  isRectangleLegend,
  gradesGoalClasses,
  textClasses,
}) {
  let text = [];
  switch (type) {
    case 'usage':
      text = [...usage];
      break;
    case 'mix':
      text = [...mix];
      break;
    case 'inquiries':
      text = [...inquiries];
      break;
    case 'age':
      text = [...age];
      break;
    case 'paymentHistory':
      text = [...paymentHistory];
      break;
    default:
    // code block
  }

  const GradesGoalGraphContainerClass = classnames(
    'GradesGoalGraphContainer',
    gradesGoalClasses,
  );

  const legend = (val, index) => {
    if (isRectangleLegend) {
      const getValidText = () => {
        const RANGES = ['F', 'D', 'C', 'B', 'A'];
        const current = RANGES[index] === you ? 'YOU' : '';
        const recommended = RANGES[index] === goal ? 'GOAL' : '';
        return { current, recommended };
      };
      let text = getValidText(val, index);
      return (
        <Rectangle
          borderColorClass={val.lineColor}
          bgColorClass={val.lineBackground}
          text={text}
        />
      );
    }
    return (
      <Line
        borderColorClass={val.lineColor}
        bgColorClass={val.lineBackground}
      />
    );
  };

  return (
    <div className={GradesGoalGraphContainerClass}>
      {config.map((val, index) => {
        const localClass =
          index === 0
            ? `goalFragmentContainer ${type} firstLine`
            : `goalFragmentContainer ${type}`;
        return (
          <div className={localClass} key={`${val}${index}`}>
            {you && !isRectangleLegend && you.toUpperCase() === val.topText ? (
              <Tag
                backgroundClass={val.youBgColor}
                colorClass={val.youFontColor}
                datatestid={
                  datatestid ? `${datatestid}-gradegoalgraph-you` : null
                }
                extClass="youClass"
              >
                You
              </Tag>
            ) : null}

            {goal &&
            !isRectangleLegend &&
            goal !== 'F' &&
            goal !== you &&
            goal.toUpperCase() === val.topText &&
            index ? (
              <Tag
                backgroundClass={val.goalBgColor}
                colorClass={val.goalFontColor}
                datatestid={
                  datatestid ? `${datatestid}-gradegoalgraph-goal` : null
                }
                extClass="goalClass"
              >
                Goal
              </Tag>
            ) : null}
            {legend(val, index)}
            <TextBelow
              topText={val.topText}
              midText={text[index].midText}
              lowerText={text[index].lowerText}
              datatestid={
                datatestid ? `${datatestid}-gradegoalgraph-text` : null
              }
              textClasses={textClasses}
              isRectangleLegend={isRectangleLegend}
            />
          </div>
        );
      })}
    </div>
  );
}

export default GradesGoalGraph;
